import U from '../js/utils';
export default async (elID, value, labelName, requiredYN, formatThousands = false) => {
  const displayValue = formatThousands ? U.formatNumberWithThousands(value) : value;
  const inputType = formatThousands ? 'text' : 'number';
  const valAttr = formatThousands ? 'formattedNumber' : 'number';
  const inputMode = formatThousands ? 'inputmode="numeric"' : '';

  const div = `
    <div id="${elID}Div" class="input-group">
      ${labelName ? `<label for="${elID}">${labelName}</label>` : ''}
      <input type="${inputType}" id="${elID}" name="${elID}" value="${displayValue}" val="${valAttr}" ${inputMode} ${requiredYN ? 'required' : ''} />
      <span fb-for="${elID}"></span>
    </div>
  `;

  const el = U.createHTMLElementFromString(div);
  if (formatThousands) {
    const input = el.querySelector('input');
    input.addEventListener('input', (e) => {
      const raw = U.parseFormattedNumber(e.target.value);
      e.target.value = raw ? U.formatNumberWithThousands(raw) : '';
    });
  }
  return el;
};
